import { Suspense, lazy } from 'react'
import { Switch, Redirect, Route } from 'react-router-dom'
import { Mode } from '@ocean/types/dist/appearance'
import { common } from '@ocean/ui'
import profileRoutes from 'modules/Profile/routing/routes'
import routes from './routes'

export { routes }

const { RouteChangeProgress } = common

export const ActivityLog = lazy(
  () =>
    import(
      /* webpackChunkName: "ActivityLog" */ 'modules/activityLog/ActivityLog/pages/ActivityLog'
    )
)

const ActivityLogRouting = () => {
  return (
    <Suspense fallback={<RouteChangeProgress mode={Mode.Light} />}>
      <Switch>
        <Route exact path={routes.root} component={ActivityLog} />
        <Redirect path='*' to={profileRoutes.root} />
      </Switch>
    </Suspense>
  )
}

export default ActivityLogRouting
